import styled from 'styled-components'


export const White = styled.div`
  position: absolute;
  top: calc(50% - 55px);
  background-repeat: no-repeat;
  width: 293px;
  height: 108px;
  z-index: 2313;
`

export const LoadingContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #050423;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events:  auto;
  ::-webkit-scrollbar {
    display: none;
  }
  & > div ::-webkit-scrollbar {
    display: none;
  }
`

export const Blue = styled.div`
  position: absolute;
  top: calc(50% - 55px);
  background-repeat: no-repeat;
  width: 293px;
  height: 108px;
  background-color: #050423;
  z-index: 2313;
  overflow: hidden;
  animation: whidthGrow linear;
  animation-duration: ${({ duration }) => (duration ? duration + 's' : '5.5s')};
  @keyframes whidthGrow {
    0% {
      width: 0;
    }
    100% {
      width: 293px;
    }
  }
`
export const Loader = styled.div`
  width: 293px;
  height: 108px;
`
